export default {
  formsTimestamp(state) {
    return state.formsTimestamp;
  },
  forms(state) {
    return state.forms;
  },
  submissions(state) {
    return state.submissions;
  },
};
